export default {
  wallet: {
    title: 'Wallet',
    balance: 'Balance',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    rollover: 'Rollover',
    transaction: 'Transaction',
    myBet: 'My Bet',
    totalBalance: 'Total Balance',
    withdrawableBalance: 'Withdrawable Balance',
    bonus: 'Bonus',
    bonusBalance: 'Bonus Balance',
    cashBalance: 'Cash Balance',
    withdrawable: 'Withdrawable',
    depositNow: 'Deposit Now',
    getBonus: 'Get Bonus',
    bonusGames: 'Bonus Games',
    playNow: 'Play Now',
    fiatAccount: 'Fiat Account',
    cash: 'Cash',
    rules: 'Rules',
    ruleQ1: '1. What is Bonus?',
    ruleA1: 'Bonus are rewards given by the platform after participating in activities and can be used to place bets in designated bonus games.',
    ruleQ2: '2. How can I use bonus?',
    ruleA2: 'Bonus can only be used for betting after the cash wallet balance is depleted. Bonus must meet the wagering requirement before they can be converted to the cash wallet.',
    ruleQ3: '3. Which games support bonus betting?',
    ruleA3: 'Most slot games support bonus betting. For a detailed list of games, please refer to the Bonus Games page.',
    ruleQ4: '4. Are there any restrictions on converting bonus to the cash wallet?',
    ruleA4: 'Once the wagering requirements for bonus betting are met, you can convert the original bonus to the cash wallet in the Rewards Center. Any remaining bonus profit will be returned to the Bonus Wallet, and the wagering requirements will be recalculated.',
    ruleQ5: '5. Are there any restrictions on converting bonus profit to the cash wallet?',
    ruleA5: 'The bonus profit must meet a 15x wagering requirement. The maximum bonus profit that can be converted to the cash wallet is USDT5,000.00, and the maximum amount per bet is USDT1,000.00.',
    ruleQ6: '6. How is the wagering requirement calculated?',
    ruleA6: 'Slot games: Wagering amount = Wagering requirement Other games: Wagering amount = Absolute value of profit (up to the bet amount)',
    select: 'Select',
    currency: 'Currency',
    loading: 'Loading...',
    noMoreData: 'No more data',
    noData: 'No data',
    colType: 'Type',
    colTime: 'Time',
    colStatus: 'Status',
    colAmount: 'Amount',
    colBalance: 'Balance',
    allType: 'All Type',
    allStats: 'All Stats',
    colWallet: 'Wallet',
    colCurrent: 'Current',
    colRequired: 'Required',
    colStats: 'Stats',
    totalVaultBalance: 'Total Vault Balance',
    amount: 'Amount',
    availableBalance: 'Available Balance:',
    max: 'MAX',
    depositInVault: 'Deposit In Vault',
    depositCurrency: 'Deposit Currency',
    currencyBalance: 'Currency Balance',
    history: 'History',
    vaultRules: 'Vault Rules',
    vaultRule1: 'The Vault is a safe place to store funds without worrying about transaction fees or delays in the blockchain. The Vault acts like your own digital wallet or even like a savings account you would have with a bank. It is extremely secure – thanks to 2FA – and you can implement enhanced safety measures to take care of the funds within.',
    vaultRule2: 'The deposit and withdrawal of funds in Vault is protected by 2FA and can be accessed by the depositor at any time.',
    vaultRule3: 'Funds in the Vault will not be touched by anyone except the depositor. It is yours, and it will always stay safe for you to use!',
    selectTime: 'Select Time',
    colGame: 'Game',
    colBet: 'Bet',
    colWin: 'Win',
    colProfit: 'Profit',
    sports: 'Sports',
    allGames: 'All games',
    today: 'Today',
    yesterday: 'Yesterday',
    last3Days: 'Last 3 days',
    last7Days: 'Last 7 days',
    last15Days: 'Last 15 days',
    last30Days: 'Last 30 days',
  },
};
